import cn from "classnames";
import { If, LinkWithArrow } from "components";
import moment from "moment";
import { useTranslation } from "react-i18next";

import { RefundType } from "../../../../../constants";
import { getReasonTextByType } from "../../../../../helpers";
import {
  RefundDetailsItemProps,
  RefundOrderDetailsProps
} from "./RefundOrderDetails.types";

import styles from "./RefundOrderDetails.module.scss";
const RefundOrderDetails = ({ refund }: RefundOrderDetailsProps) => {
  const { t } = useTranslation();

  const { deliveryZone } = refund.order.deliveryAddress;

  const RefundDetailsItem = ({
    title,
    info,
    className
  }: RefundDetailsItemProps) => {
    return (
      <div className={cn(styles.refund__details, className)}>
        <If condition={!!title}>
          <p className={styles["refund__details--title"]}>{title}</p>
        </If>

        {info}
      </div>
    );
  };

  const getReasonText = () => {
    switch (refund.type) {
      case RefundType.OrderReturn:
        return (
          <pre>
            {refund.order.returnReason}
            {"\n"}
            {refund.order.returnDescription}
          </pre>
        );
      case RefundType.OrderCancellation:
      case RefundType.OrderFailure:
        return refund.order.cancellationReason;

      default:
        return null;
    }
  };

  return (
    <>
      <div className={styles.order__details}>
        <RefundDetailsItem
          title={t("Order Number")}
          info={
            <>
              <p>{refund.orderId}</p>
              <LinkWithArrow
                to={`/orders?orderId=${refund.orderId}`}
                text={t("Show order")}
              />
            </>
          }
        />

        <RefundDetailsItem
          title={t("Delivery Address")}
          info={
            <div className={styles["order__details--item"]}>
              <p className={styles["order__details--item-user"]}>
                {refund.order.deliveryAddress.fullName}
              </p>
              <p>{refund.order.deliveryAddress.phoneNumber}</p>
              <p>
                {`${deliveryZone.country}, ${deliveryZone.city}, ${deliveryZone.neighborhood}`}
              </p>
              <p>{refund.order.deliveryAddress.address}</p>
            </div>
          }
        />
        <RefundDetailsItem
          title={t("Refund Method")}
          info={refund.mobileMoneyNumber}
        />
        <RefundDetailsItem
          title={t("Refund date")}
          info={
            <pre>
              {`${moment(refund.createdAt).format("DD/MM/YYYY")}`}
              {"\n"}
              {`${moment(refund.createdAt).format("HH:mm")}`}
            </pre>
          }
        />
      </div>

      <RefundDetailsItem
        className={styles.order__refund}
        title={t("Reason")}
        info={
          <>
            <p className={styles["order__refund--reason"]}>
              {t(getReasonTextByType(refund.type))}
            </p>

            <div className={styles["order__refund--reason-description"]}>
              {getReasonText()}
            </div>
          </>
        }
      />
    </>
  );
};

export default RefundOrderDetails;
